import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';

import { NgbDateStruct, NgbTimepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import {Task, WpPerson, TaskSearch, WpReferral, Appointment, AppointmentCorrespondence, FileResponse} from '../shared';
import { DateUtility, TimeUtility, CommonUtility, ServerConstantsService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-manual-correspondence',
  templateUrl: './manual-correspondence.component.html',
  styleUrls: ['./manual-correspondence.component.scss']
})
export class ManualCorrespondenceComponent implements OnInit {
  referralId: string = '';
  wpPersonId: string = '';
  appointmentGenerate: Appointment;
  appointments: Appointment[];
  appointmentTypes: any;
  appointmentStatus: any;
  appointmentTime: any;
  url: String = '';
  sub: any;
  alreadyExist: Boolean = false;
  noData: Boolean = false;
  task: Task;
  tasks: Task[];
  wpPerson: WpPerson;
  wpReferral: WpReferral;
  time: NgbTimeStruct = { hour: 8, minute: 0, second: 0 };
  private _danger = new Subject<string>();
  errorMessage: string;
  private _success = new Subject<string>();
  successMessage: string;
  ServerConstants: any;
  // copyAppointmentStatus: any;
  refData: any;
  appointmentStatusMap: any;
  appointmentTypeMap: any;
  disableDropDown: Boolean = false;
  hours: any;
  minutes: any;
  meridian: any;
  selectedMin: any;
  selectedHour: any;
  selectedMer: any;
  disableButton: Boolean = false;
  userActionNotificationsMap: any;
  sharedData: any;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  serverConstants: any;
  today: Date = new Date();
  taskSearch: TaskSearch;
  taskDueDateFrom: any;

  taskDueDateTo: any;
  todayPlus: Date = new Date();
  errorAptDateField: string = null;
  appTaskExist: boolean;

  appointmentCorrespondence: AppointmentCorrespondence;
  fileResponse: FileResponse ;
  returnOK: boolean;
  appointmentCorrespondenceResult: AppointmentCorrespondence;

  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              config: NgbTimepickerConfig,
              private dateUtil: DateUtility,
              private timeUtil: TimeUtility,
              private data: ReferenceTableService,
              private commonUtil: CommonUtility,
              private dataService: DataService,
              private router: Router,
              private notificationService: NotificationsService,
              private serverConstantsService: ServerConstantsService) {

    this.serverConstants = serverConstantsService.getConstants();
    config.seconds = false;
    config.spinners = false;
    this.hours = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    this.minutes = ["00", "15", "30", "45"];
    this.meridian = ["AM", "PM"];
    this.selectedHour = "";
    this.selectedMin = "";
    this.selectedMer = "AM";
  }

  ngOnInit() {
    this.sharedData = this.dataService.getSharedDataObject();
    this.appTaskExist = false;
    this.minDate = {
      month: this.today.getMonth() + 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };

    this.todayPlus = new Date( this.todayPlus.setMonth(this.todayPlus.getMonth() + 6) );

    this.maxDate = {
      month: this.todayPlus.getMonth() + 1,
      day: this.todayPlus.getDate(),
      year: this.todayPlus.getFullYear()
    };

    this.getRefData();
    this.appointmentGenerate = new Appointment();
    this.appointmentGenerate.wpPerson = new WpPerson();
    this.appointmentGenerate.wpTask = new Task();
    this.wpPerson = this.sharedData.get('wpSharePerson');
    console.log(this.wpPerson);
    this.appointmentGenerate.wpPerson = this.wpPerson;

    console.log(this.wpPerson);
    this.searchAppTasksForIndv(this.appointmentGenerate.wpPerson);
  }

  searchAppTasksForIndv(selected) {
    const person = new WpPerson();
    const referral = new WpReferral();
    const indvTask = new Task();
    this.taskSearch = new TaskSearch();

    person.id = selected.personId;
    referral.id = selected.referralId;
    indvTask.wpPerson = person;
    indvTask.wpReferral = referral;
    this.taskSearch.task = indvTask;

    /* Get only task type appointment */
    this.taskSearch.task.taskType = "AP";
    //this.taskSearch.task.taskStatus = "OP"

    this.searchAppTask();
  }
  searchAppTask() {
    this.http.post<TaskSearch>(this.serverConstants.SERVER_API_URL + '/tasks/search', this.taskSearch).subscribe(
      (val) => {
        console.log("task")
        console.log(val)
        this.taskSearch = val;

        if(this.taskSearch.tasks.length > 0 ){
          //this.notificationService.success('Task search for appointment found', this.userActionNotificationsMap.UPDATE);
          this.appTaskExist = true;
          this.appointmentGenerate.wpTask = this.taskSearch.tasks[0];
        }
        else{
          this.notificationService.error('Task search for appointment not found, please create one', this.userActionNotificationsMap.ERROR);
          //this.returnToCorrespondence();
        }
      },
      response => {
        this.notificationService.error('Task search for appointment error', this.userActionNotificationsMap.ERROR);
        this.returnToCorrespondence();
      },
      () => {
      });
  }

  getRefData() {
    this.data.currentMessage.subscribe(
      (message) => {
        this.refData = message;
        this.parseRefTableData(message);
      });
  }
  parseRefTableData(myData) {
    if (myData != undefined && myData.englishDropDown) {
      this.appointmentTypes = myData.englishDropDown["appointmentType"];
      this.appointmentStatus = myData.englishDropDown["appointmentStatus"];
      this.appointmentStatusMap = this.commonUtil.createMapFromList(this.appointmentStatus);
      this.appointmentTypeMap = this.commonUtil.createMapFromList(this.appointmentTypes);
      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
    }
  }
  disabledAllFields() {
    this.disableDropDown = true;
    this.disableButton = true;
    this.alreadyExist = true;
  }
  toggleButton() {
    this.alreadyExist = false;
    return this.alreadyExist;
  }

  saveAppointment() {
    /* convert date and also change status to Schedule */
    this.appointmentGenerate.appointmentDt = this.dateUtil.convertDateForServer(this.appointmentGenerate.appointmentDt);
    if (this.selectedHour != "" && this.selectedMin != "") {
      this.appointmentGenerate.appointmentTime = this.timeUtil.convertMeridianTimeForServer(this.appointmentGenerate.appointmentDt, this.selectedHour, this.selectedMin, this.selectedMer);
    }
    /*if (this.appointmentGenerate.appointmentStatusCd == '' || this.appointmentGenerate.appointmentStatusCd == null || this.appointmentGenerate.appointmentStatusCd == "null") {
      this.appointmentGenerate.appointmentStatusCd = 'SH';
    } else if (this.appointmentGenerate.appointmentStatusCd == 'SH') {
      this.appointmentGenerate.appointmentStatusCd = 'RS';
    }*/

    this.appointmentGenerate.referralId = this.appointmentGenerate.wpTask.wpReferral.id;
    this.http.post(this.serverConstants.SERVER_API_URL + "/appointment/save", this.appointmentGenerate).subscribe(
      (val) => {
        if (val.hasOwnProperty('errorCode')) {
          this.notificationService.error('Appointment error', this.userActionNotificationsMap.ERROR);
        } else {
          this.notificationService.success('Appointment created', this.userActionNotificationsMap.UPDATE);
          this.appointmentGenerate = val;
          /* Generate correspondence*/
          this.appointmentCorrespondence  = new AppointmentCorrespondence();
          //this.appointmentCorrespondence.appointment = this.appointmentGenerate;
          //this.appointmentCorrespondence.appointmentType = this.convertCode(this.appointmentTypeMap, this.appointmentGenerate.appointmentType);
          //this.appointmentCorrespondence.appointment.wpPerson = this.wpPerson;
          this.actionGenerate(this.appointmentCorrespondence);

        }
      },
      response => {
        this.notificationService.error('Appointment', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }



  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }


  findCorrespondence(appointment: Appointment ){
    this.appointmentCorrespondenceResult = new AppointmentCorrespondence();
    //this.appointmentCorrespondenceResult.appointment = appointment;
    this.http.post<any>(this.serverConstants.CORRESPONDENCE_API_URL + '/correspondence/find', this.appointmentCorrespondenceResult).subscribe(
      (val: any) => {
        this.appointmentCorrespondenceResult = val;
      },
      response => {
        //this.wpDocTriggerInfo.id = -1;
        this.notificationService.error('Correspondence Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
        /*this.appointmentCorrespondenceResult.appointmentType = this.convertCode(this.appointmentTypeMap,
          this.appointmentCorrespondenceResult.appointment.appointmentType);*/

        /*let correspondence  = new AppointmentCorrespondence();
        correspondence.appointment = appointment;
        correspondence.appointmentType = this.convertCode(this.appointmentTypeMap, appointment.appointmentType);
        correspondence.fileResponse = this.fileResponse;
        this.appointmentCorrespondence = correspondence;
*/
        //this.actionDownload(this.appointmentCorrespondenceResult.fileResponse);
      });
  }

  actionGenerate(appointmentCorrespondence: AppointmentCorrespondence){
    this.http.post<any>(this.serverConstants.CORRESPONDENCE_API_URL + '/correspondence/generate', appointmentCorrespondence).subscribe(
      (val: any) => {
        appointmentCorrespondence = val;

        //this.findCorrespondence(this.appointmentCorrespondence.appointment);
        console.log(this.appointmentCorrespondence)

      },
      response => {
        this.notificationService.error('Error in generate appointment correspondence', this.userActionNotificationsMap.ERROR);
      },
      () => {
        //this.actionDownload(appointmentCorrespondence.fileResponse);
        /*if(appointmentCorrespondence.fileResponse != null){

        }*/

      });
  }

  actionDownload(file){
    /*const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.token.getToken()
      })
    };*/

    this.http.get<any>(file.fileDownloadUri, {
        //headers: {'Authorization': 'Bearer ' + this.token.getToken()},
        responseType: 'blob' as 'json'
      }
    )
      .map(res => {
        return {
          filename: file.fileName,
          data: res
        };
      })
      .subscribe(
        (res: any) => {
          var url = window.URL.createObjectURL(res.data);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = res.filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element

          this.notificationService.success('File downloaded', this.userActionNotificationsMap.UPDATE);
          this.dataService.removeValueFromSharedDataMap("wpSharePerson");
          this.returnToCorrespondence();

        }, response => {

        });
  }


  returnToCorrespondence(){
    this.router.navigate(['correspondence']);


  }

}



// WEBPACK FOOTER //
// ./src/app/manual-correspondence/manual-correspondence.component.ts